import { useMemo } from 'react';
import { useCurrentUser } from './useCurrentUser';

/**
 * Whether the account has a card on file, and what to show for it.
 *
 * The field names are Cashier's — `pm_type` and `pm_last_four` on `UserResource`, where the Lumen
 * query called them `card_brand` and `card_last_four`. Renamed here rather than at the three
 * screens that render them, which go on asking for a brand and a last four.
 */
export const usePayment = () => {
  const { data: currentUserData } = useCurrentUser();
  const hasPaymentMethod = useMemo<boolean>(() => !!currentUserData?.pm_last_four, [currentUserData?.pm_last_four]);

  return {
    hasPaymentMethod,
    cardLastFour: currentUserData?.pm_last_four,
    cardBrand: currentUserData?.pm_type,
  };
};
